import { useEffect, useState } from "react";
import { Button, Dimensions, Image, Platform, Text, TextInput, TouchableOpacity, View } from "react-native";
import AwesomeAlert from "react-native-awesome-alerts";
import BouncyCheckbox from "react-native-bouncy-checkbox";
import CalendarPicker from "react-native-calendar-picker";
import { dateMinusMinutes, datePlusMinutes, getDateFromDateAndTimeObjects, getIsdateBetweenDates, getTimeOfTimestamptz, getTimestamptz, timestamptzToDate } from "../../helpers/time";
import { getIsMobile, getMainContainerPadding, getResponsiveWidth, placeholderTextColor, redHexColor, softLabelColor, styles } from "../../styles/styles";
import { supabase } from "../../supabase/supabase";
import { getDateAvailableSchedules, getDateDeliverySchedules, sendNewDeliveryNotifications } from "../../supabase/supabaseController";
import LoggedTemplate from "../LoggedTemplate";
import SectionContainer from "../SectionContainer";
import TimerInput from "../TimerInput/TimerInput";
import * as ImagePicker from "expo-image-picker";
import * as FileSystem from "expo-file-system";
import { decode } from "base64-arraybuffer";
import DropDownPicker from "react-native-dropdown-picker";
import { productImagesURL } from "../../supabase/credentials";
import { widthPercentageToDP, heightPercentageToDP } from "react-native-responsive-screen";

export default function DeliveryForm(props) {
	let { navigation, route } = props;

	let today = new Date();
	today.setHours(0, 0, 0, 0);

	const { delivery } = route.params ?? { delivery: undefined };

	let defaults = {
		client: "",
		clientPhone: "",
		packageDescription: "",
		image: null,
		date: today,
		time: undefined,
		payed: false,
		price: "",
		place: null,
		beforeLength: 0,
		deliveryLength: 10,
		afterLength: 0,
	};

	if (delivery) {
		defaults = {
			client: delivery.client,
			clientPhone: delivery.client_phone,
			packageDescription: delivery.package_description,
			image: productImagesURL + delivery.id,
			date: timestamptzToDate(delivery.time),
			time: getTimeOfTimestamptz(delivery.time),
			payed: delivery.payed,
			price: delivery.price,
			place: delivery.place,
			beforeLength: delivery.before_length,
			deliveryLength: delivery.delivery_length,
			afterLength: delivery.after_length,
		};
	}

	const [client, setClient] = useState(defaults.client);
	const [clientPhone, setClientPhone] = useState(defaults.clientPhone);
	const [packageDescription, setPackageDescription] = useState(defaults.packageDescription);
	const [image, setImage] = useState(defaults.image);
	const [date, setDate] = useState(defaults.date);
	const [time, setTime] = useState(defaults.time);
	const [payed, setPayed] = useState(defaults.payed);
	const [price, setPrice] = useState(defaults.price);
	const [place, setPlace] = useState(defaults.place);
	const [beforeLength, setBeforeLength] = useState(defaults.beforeLength);
	const [deliveryLength, setDeliveryLength] = useState(defaults.deliveryLength);
	const [afterLength, setAfterLength] = useState(defaults.afterLength);

	const [isTimeModified, setIsTimeModified] = useState(undefined);

	const [showMessageAlert, setShowMessageAlert] = useState(false);
	const [showErrorAlert, setShowErrorAlert] = useState(false);
	const [showLoadingAlert, setShowLoadingAlert] = useState(false);

	const [errorMessage, setErrorMessage] = useState(undefined);

	const [isOpenPlaceDropDown, setIsOpenPlaceDropDown] = useState(false);
	const [isOpenBeforeLengthDropDown, setIsOpenBeforeLengthDropDown] = useState(false);
	const [isOpenDeliveryLengthDropDown, setIsOpenDeliveryLengthDropDown] = useState(false);
	const [isOpenAfterLengthDropDown, setIsOpenAfterLengthDropDown] = useState(false);

	const [deliveryLengthsItems, setDeliveryLengthsItems] = useState([
		{ label: "10 minutos", value: 10 },
		{ label: "15 minutos", value: 15 },
		{ label: "30 minutos", value: 30 },
		{ label: "60  minutos", value: 60 },
	]);

	const [beforeAndAfterLengthsItems, setBeforeAndAfterLengthsItems] = useState([{ label: "0  minutos", value: 0 }, ...deliveryLengthsItems]);

	const estacionesDelMetro = ["Acatitla", "Aculco", "Agrícola Oriental", "Allende", "Apatlaco", "Aquiles Serdán", "Aragón", "Atlalilco", "Auditorio", "Autobuses del Norte", "Azcapotzalco", "Balbuena", "Balderas", "Barranca del Muerto", "Bellas Artes", "Bondojito", "Bosque de Aragón", "Boulevard Puerto Aéreo", "Buenavista", "Calle 11", "Camarones", "Canal del Norte", "Canal de San Juan", "Candelaria", "Centro Médico", "Cerro de la Estrella", "Chabacano", "Chapultepec", "Chilpancingo", "Ciudad Azteca", "Ciudad Deportiva", "Colegio Militar", "Constitución de 1917", "Constituyentes", "Consulado", "Copilco", "Coyoacán", "Coyuya", "Cuatro Caminos", "Cuauhtémoc", "Cuitláhuac", "Culhuacán", "Deportivo 18 de Marzo", "Deportivo Oceanía", "División del Norte", "Doctores", "Ecatepec", "Eduardo Molina", "Eje central", "El Rosario", "Ermita", "Escuadrón 201", "Etiopía/Plaza de la Transparencia", "Eugenia", "Ferrería", "Fray Servando", "Garibaldi", "General Anaya", "Gómez Farías", "Guelatao", "Guerrero", "Hangares", "Hidalgo", "Hospital 20 de Noviembre", "Hospital General", "Impulsora", "Indios Verdes", "Instituto del Petróleo", "Insurgentes", "Insurgentes Sur", "Isabel la Católica", "Iztacalco", "Iztapalapa", "Jamaica", "Juanacatlán", "Juárez", "Lagunilla", "La Paz", "La Raza", "La Viga", "La Villa-Basílica", "Lázaro Cárdenas", "Lindavista", "Los Reyes", "Miguel Ángel de Quevedo", "Martín Carrera", "Merced", "Mexicaltzingo", "Misterios", "Mixcoac", "Mixiuhca", "Moctezuma", "Morelos", "Múzquiz", "Nativitas", "Nezahualcóyotl", "Niños Héroes", "Nopalera", "Normal", "Norte 45", "Obrera", "Observatorio", "Oceanía", "Olímpica", "Olivos", "Panteones", "Pantitlán", "Parque de los venados", "Patriotismo", "Peñón Viejo", "Periférico Oriente", "Pino Suárez", "Plaza Aragón", "Polanco", "Politécnico", "Popotla", "Portales", "Potrero", "Puebla", "Refinería", "Revolución", "Ricardo Flores Magón", "Río de los Remedios", "Romero Rubio", "Salto del Agua", "San Andrés Tomatlán", "San Antonio", "San Antonio Abad", "San Cosme", "San Joaquín", "San Juan de Letrán", "San Lázaro", "San Pedro de los Pinos", "Santa Anita", "Santa Marta", "Sevilla", "Tacuba", "Tacubaya", "Talismán", "Tasqueña", "Tepalcates", "Tepito", "Terminal Aérea", "Tezonco", "Tezozómoc", "Tláhuac", "Tlaltenco", "Tlatelolco", "UAM-I", "Universidad", "Valle Gómez", "Vallejo", "Velódromo", "Viaducto", "Villa de Aragón", "Villa de Cortés", "Viveros/Derechos Humanos", "Xola", "Zapata", "Zapotitlán", "Zaragoza", "Zócalo"];

	const stateEstacionesDelMetroItems = estacionesDelMetro.map((element) => {
		return { label: element, value: element };
	});

	const [estacionesDelMetroItems, setEstacionesDelMetroItems] = useState(stateEstacionesDelMetroItems);

	const showError = (e, message = "Ha ocurrido un error en el servidor") => {
		console.log(e);

		setErrorMessage(message);
		setShowErrorAlert(true);

		setShowLoadingAlert(false);
	};

	const window = Dimensions.get("window");
	const screen = Dimensions.get("screen");

	const [dimensions, setDimensions] = useState({ window, screen });

	useEffect(() => {
		const subscription = Dimensions.addEventListener("change", ({ window, screen }) => {
			setDimensions({ window, screen });
		});
		return () => subscription?.remove();
	});

	const sendForm = async () => {
		if (client && clientPhone && packageDescription && time && image && price && place) {
			setShowLoadingAlert(true);
			let availableSchedules = await getDateAvailableSchedules(date);
			let deliverySchedules = await getDateDeliverySchedules(date);

			let deliveryStartDate = dateMinusMinutes(getDateFromDateAndTimeObjects(date, time), parseInt(beforeLength));
			let deliveryEndDate = datePlusMinutes(getDateFromDateAndTimeObjects(date, time), parseInt(deliveryLength) + parseInt(afterLength));

			let isDeliveryPersonAvailable;

			availableSchedules.forEach((e) => {
				let betweenStartDate = timestamptzToDate(e.start_date);
				let betweenEndDate = timestamptzToDate(e.end_date);

				if (getIsdateBetweenDates(deliveryStartDate, betweenStartDate, betweenEndDate) && getIsdateBetweenDates(deliveryEndDate, betweenStartDate, betweenEndDate)) {
					isDeliveryPersonAvailable = true;
				}
			});

			if (!isDeliveryPersonAvailable) {
				showError(null, "La hora no cabe en el horario libre de un repartidor");
				return;
			}

			if (delivery) deliverySchedules = deliverySchedules.filter((e) => e.id !== delivery.id);

			let hayTraslape;

			deliverySchedules.forEach((e) => {
				let betweenStartDate = dateMinusMinutes(timestamptzToDate(e.time), e.before_length);
				let betweenEndDate = datePlusMinutes(timestamptzToDate(e.time), e.delivery_length + e.after_length);

				if (getIsdateBetweenDates(deliveryStartDate, betweenStartDate, betweenEndDate) || getIsdateBetweenDates(deliveryEndDate, betweenStartDate, betweenEndDate)) {
					hayTraslape = true;
				}
			});

			if (hayTraslape) {
				showError(null, "La hora se traslapa con la de otra entrega");
				return;
			}

			const userId = supabase.auth.user().id;

			let data, error;

			({ data, error } = await supabase.from("delivery_schedule").insert([
				{
					client: client,
					client_phone: clientPhone,
					package_description: packageDescription,
					time: getTimestamptz(date, time),
					before_length: beforeLength,
					delivery_length: deliveryLength,
					after_length: afterLength,
					payed: payed,
					price: price,
					place: place,
					user_id: userId,
				},
			]));

			if (error) {
				showError(error);
				return;
			}

			let file, type;

			// ImagePicker saves the taken photo to disk and returns a local URI to it
			let localUri = image;
			let filename = localUri.split("/").pop();

			// Infer the type of the image
			if (Platform.OS !== "web") {
				let match = /\.(\w+)$/.exec(filename);

				type = match ? match[1] : null;

				const base64 = await FileSystem.readAsStringAsync(image, { encoding: FileSystem.EncodingType.Base64 });

				file = decode(base64);
			} else {
				const response = await fetch(image);
				const blob = await response.blob();

				file = new File([blob], `filename`);
			}

			// Upload the image using the fetch and FormData APIs
			let formData = new FormData();
			// Assume `product${data[0].id}` is the name of the form field the server expects
			formData.append(`product${data[0].id}`, { uri: localUri, name: filename, type });

			// let supabaseFilename = `product${data[0].id}${type ? "." + type : ""}`;
			let supabaseFilename = `product${data[0].id}`;

			({ data, error } = await supabase.storage.from("products").upload(supabaseFilename, file, {
				contentType: type ? `image/${type}` : "image",
			}));

			if (error) {
				showError(error);
				return;
			}

			if (delivery) {
				let data, error;

				({ data, error } = await supabase.from("delivery_schedule").delete().eq("id", delivery.id));

				({ data, error } = await supabase.storage.from("products").remove(["product" + delivery.id]));

				if (error) {
					showError(error);
					return;
				}
			}

			await sendNewDeliveryNotifications();

			setShowMessageAlert(true);
			setShowLoadingAlert(false);
		} else {
			setErrorMessage("¡Alto ahí! Debes llenar todos los campos.");
			setShowErrorAlert(true);
		}
	};

	const pickImage = async () => {
		// No permissions request is necessary for launching the image library
		let result = await ImagePicker.launchImageLibraryAsync({
			mediaTypes: ImagePicker.MediaTypeOptions.All,
			// allowsEditing: true,
			// aspect: [4, 3],
			quality: 1,
		});

		if (!result.canceled) {
			setImage(result.assets ? result.assets[0].uri : result.uri);
		}
	};

	const hideAlerts = () => {
		setShowMessageAlert(false);
		setShowErrorAlert(false);
	};

	const restartState = () => {
		setClient(defaults.client);
		setClientPhone(defaults.clientPhone);
		setPackageDescription(defaults.packageDescription);
		setImage(defaults.image);
		setDate(defaults.date);
		setTime(defaults.time);
		setPayed(defaults.payed);
		setPrice(defaults.price);
		setPlace(defaults.place);
		setBeforeLength(defaults.beforeLength);
		setDeliveryLength(defaults.deliveryLength);
		setAfterLength(defaults.afterLength);
	};

	return (
		<>
			<LoggedTemplate
				navigation={navigation}
				route={route}>
				<SectionContainer style={{ backgroundColor: "#efd5e3" }}>
					<View style={[styles.headerDeliveryForm]}>
						<Text style={[styles.headerDeliveryFormText]}>Programa tu entrega</Text>
						<Text style={[styles.textDeliveryFormText]}>¡Deprisa! Llena los datos de tu pedido para notificar al demonio repartidor.</Text>
					</View>
				</SectionContainer>
				<SectionContainer style={{ flexGrow: 1, paddingTop: 20 }}>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Cliente</Text>
						</View>
						<View>
							<TextInput
								style={styles.textInput}
								placeholder="Nombre o alias del cliente"
								placeholderTextColor={placeholderTextColor}
								onChangeText={(input) => {
									setClient(input);
								}}
								value={client}></TextInput>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Teléfono</Text>
						</View>
						<View>
							<TextInput
								style={styles.textInput}
								placeholder="(722) 123 4567"
								placeholderTextColor={placeholderTextColor}
								onChangeText={(input) => {
									setClientPhone(input);
								}}
								value={clientPhone}></TextInput>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Paquete</Text>
						</View>
						<View>
							<TextInput
								style={styles.textInput}
								multiline={true}
								numberOfLines={4}
								placeholder="Describe el paquete a entregar..."
								placeholderTextColor={placeholderTextColor}
								onChangeText={(input) => {
									setPackageDescription(input);
								}}
								value={packageDescription}></TextInput>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View style={styles.formInputContainer}>
							<TouchableOpacity
								style={styles.touchableOpacityButton}
								onPress={pickImage}>
								<View style={[styles.button]}>
									<Text style={[styles.buttonText]}>SUBE UNA IMAGEN DEL PRODUCTO</Text>
								</View>
							</TouchableOpacity>
						</View>
						<View style={[{ width: "100%", alignItems: "center", justifyContent: "center" }]}>
							{image ? (
								<Image
									source={{ uri: image }}
									style={{ width: getResponsiveWidth(100, dimensions.window.width), height: getResponsiveWidth(100, dimensions.window.width) }}
								/>
							) : (
								<Text style={styles.noPedidos}>No se ha escogido una imagen</Text>
							)}
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Día</Text>
						</View>
						{/* <View>
						<Text style={styles.textInput}>{startDate}</Text>
					</View> */}
						<View style={styles.calendarContainer}>
							<CalendarPicker // scaleFactor={700}
								width={getResponsiveWidth(95, dimensions.window.width)}
								onDateChange={(date) => {
									setDate(date.toDate());
								}}
								selectedStartDate={date}
								disabledDates={(date) => date < today}
								weekdays={["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"]}
								months={["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]}
								previousTitle="Anterior"
								nextTitle="Siguiente"
								selectedDayStyle={{ backgroundColor: "#c6364d" }}
								selectedDayTextColor="white"
							/>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Hora</Text>
						</View>
						<View>
							<TimerInput
								time={time}
								onValueChange={(time) => {
									setTime(time);
								}}
								valueNotModified={isTimeModified}></TimerInput>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Pago completado</Text>
						</View>
						<View>
							<BouncyCheckbox
								size={20}
								fillColor={redHexColor}
								textStyle={[
									styles.formInputLabel,
									{
										textDecorationLine: "none",
										fontFamily: "Raleway-Regular",
										marginLeft: -8,
									},
								]}
								style={{
									borderRadius: 0,
									marginLeft: 10,
									marginTop: 10,
								}}
								text="Pagado"
								onPress={(input) => {
									setPayed(input);
								}}
							/>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<View>
							<Text style={styles.formInputLabel}>Cuota de entrega</Text>
						</View>
						<View style={{ flexDirection: "row", alignItems: "center" }}>
							<Text style={styles.inputPrefix}>$</Text>
							<TextInput
								style={[styles.textInput, { flexGrow: 1 }]}
								placeholder="15.00"
								placeholderTextColor={placeholderTextColor}
								onChangeText={(input) => {
									setPrice(input.match(/[0-9]*([.][0-9]*)?/)[0]);
								}}
								value={price}></TextInput>
						</View>
					</View>
					<View style={[styles.formInputContainer, { zIndex: isOpenPlaceDropDown ? 2000 : 1000 }]}>
						<View>
							<Text style={styles.formInputLabel}>Estación del metro</Text>
						</View>
						<View>
							<DropDownPicker
								style={[styles.textInput, { flexGrow: 1, borderWidth: 0 }]}
								placeholder="Selecciona una estación"
								placeholderStyle={{
									color: placeholderTextColor,
									fontFamily: "Raleway-Regular",
								}}
								textStyle={styles.textDropDownPicker}
								open={isOpenPlaceDropDown}
								value={place}
								items={estacionesDelMetroItems}
								setOpen={setIsOpenPlaceDropDown}
								setValue={setPlace}
								setItems={setEstacionesDelMetroItems}
								listMode={Platform.OS !== "web" ? "MODAL" : "FLATLIST"}
								// scrollViewProps={{
								// 	nestedScrollEnabled: true,
								// }}
							/>
						</View>
					</View>
					<View style={[styles.formInputContainer, { zIndex: isOpenBeforeLengthDropDown ? 2000 : 1000 }]}>
						<View>
							<Text style={styles.formInputLabel}>Tiempo estimado de llegada</Text>
						</View>
						<View style={{ flexDirection: "row", alignItems: "center" }}>
							<DropDownPicker
								style={[styles.textInput, { flexGrow: 1, borderWidth: 0, }]}
								textStyle={styles.textDropDownPicker}
								open={isOpenBeforeLengthDropDown}
								value={beforeLength}
								items={beforeAndAfterLengthsItems}
								setOpen={setIsOpenBeforeLengthDropDown}
								setValue={setBeforeLength}
								setItems={setBeforeAndAfterLengthsItems}
							/>
						</View>
					</View>
					<View style={[styles.formInputContainer, { zIndex: isOpenDeliveryLengthDropDown ? 2000 : 1000 }]}>
						<View>
							<Text style={styles.formInputLabel}>Tiempo de espera</Text>
						</View>
						<View style={{ flexDirection: "row", alignItems: "center" }}>
							<DropDownPicker
								style={[styles.textInput, { flexGrow: 1, borderWidth: 0 }]}
								textStyle={styles.textDropDownPicker}
								open={isOpenDeliveryLengthDropDown}
								value={deliveryLength}
								items={deliveryLengthsItems}
								setOpen={setIsOpenDeliveryLengthDropDown}
								setValue={setDeliveryLength}
								setItems={setDeliveryLengthsItems}
							/>
						</View>
					</View>
					<View style={[styles.formInputContainer, { zIndex: isOpenAfterLengthDropDown ? 2000 : 1000 }]}>
						<View>
							<Text style={styles.formInputLabel}>Tiempo estimado de regreso</Text>
						</View>
						<View style={{ flexDirection: "row", alignItems: "center" }}>
							<DropDownPicker
								style={[styles.textInput, { flexGrow: 1, borderWidth: 0 }]}
								textStyle={styles.textDropDownPicker}
								open={isOpenAfterLengthDropDown}
								value={afterLength}
								items={beforeAndAfterLengthsItems}
								setOpen={setIsOpenAfterLengthDropDown}
								setValue={setAfterLength}
								setItems={setBeforeAndAfterLengthsItems}
							/>
						</View>
					</View>
					<View style={styles.formInputContainer}>
						<TouchableOpacity
							style={styles.touchableOpacityButton}
							onPress={sendForm}>
							<View style={[styles.button]}>
								<Text style={[styles.buttonText]}>GUARDAR</Text>
							</View>
						</TouchableOpacity>
					</View>
				</SectionContainer>
			</LoggedTemplate>
			<AwesomeAlert
				show={showMessageAlert}
				showProgress={false}
				title="¡Perfecto!"
				message="Se ha añadido correctamente"
				closeOnTouchOutside={true}
				closeOnHardwareBackPress={true}
				showConfirmButton={true}
				confirmText="Ok"
				// confirmButtonColor="#DD6B55"
				onConfirmPressed={() => {
					hideAlerts();
					restartState();
					if (!delivery) {
						navigation.navigate("Calendar");
					} else {
						navigation.navigate("Home");
					}
				}}
				onDismiss={() => {
					hideAlerts();
					restartState();
					if (!delivery) {
						navigation.navigate("Calendar");
					} else {
						navigation.navigate("Home");
					}
				}}
			/>
			<AwesomeAlert
				show={showErrorAlert}
				showProgress={false}
				title="Error"
				message={errorMessage}
				closeOnTouchOutside={true}
				closeOnHardwareBackPress={true}
				showConfirmButton={true}
				confirmText="Ok"
				confirmButtonColor="#DD6B55"
				onConfirmPressed={hideAlerts}
				onDismiss={hideAlerts}
			/>
			<AwesomeAlert
				show={showLoadingAlert}
				showProgress={true}
				title="Cargando..."
				message="Espere un momento, por favor"
				closeOnTouchOutside={false}
				closeOnHardwareBackPress={false}
			/>
		</>
	);
}
